import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
    LocalEditableIntegration,
    IntegrationCompany,
    integrationsByCompany
} from "../../../Everou/_modelsTS/Integration";
import { MainPageWithButtons } from "../../../Everou/_components";
import { removeFromArr } from "../../../Common/_utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { Selectors } from "../../../Everou/_reducers/app.reducer";
import { PMSIntegrationsActions } from "../../_actions/PMSIntegrationsActions";
import { PMSAvantioIntegrationInput } from "../_components/PMSAvantioIntegrationInput";
import { useAccountDraft } from "../_hooks/useAccountDraft";

export function PMSAvantioIntegration() {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const serverIntegrations = useSelector(Selectors.getPMSIntegrationsInPanel);
    const accountDraft = useAccountDraft(IntegrationCompany.AVANTIO);
    const serverEditableIntegrations = serverIntegrations.map(
        (integration) => ({ ...integration, editable: false }),
    );

    const [integrationsLocal, setIntegrationsLocal] =
        useState<LocalEditableIntegration[]>(
        () => integrationsByCompany(serverIntegrations, IntegrationCompany.AVANTIO, accountDraft),
    );

    useEffect(() => {
        const updatedIntegrations = integrationsByCompany(serverIntegrations, IntegrationCompany.AVANTIO, accountDraft);
        setIntegrationsLocal(updatedIntegrations);
    }, [serverIntegrations, accountDraft])

    const onDeleteIntegration = (index: number) => {
        const integration = integrationsLocal[index];
        if (!integration.uid) {
            setIntegrationsLocal(
                removeFromArr<LocalEditableIntegration>(index, integrationsLocal),
            );
        } else {
            dispatch(
                PMSIntegrationsActions.deleteIntegration(
                    integration.uid,
                ),
            );
        }
    };

    const toggleEditable = (index: number) => {
        const updatedIntegrations = integrationsLocal.map(
            (integration, maxIndex) =>
                index === maxIndex
                    ? { ...integration, editable: !integration.editable }
                    : integration,
        );
        setIntegrationsLocal(updatedIntegrations);
    };

    const onSetInitialStatus = (index: number) => {
        const updatedIntegrations = integrationsLocal.map(
            (integration, maxIndex) =>
                index === maxIndex
                    ? serverEditableIntegrations[index]
                    : integration,
        );
        setIntegrationsLocal(updatedIntegrations);
    };

    const body = (
        <div className="c-grid c-grid--small rounded-bottom">
            {integrationsLocal.map((integration, index) => (
                <PMSAvantioIntegrationInput
                    key={integration.uid || "new"}
                    onSetInitialStatus={(index) => onSetInitialStatus(index)}
                    onDelete={(index) => onDeleteIntegration(index)}
                    index={index}
                    onToggleEditable={(index) => toggleEditable(index)}
                    integration={integration}
                />
            ))}
        </div>
    );

    return (
        <MainPageWithButtons
            //dataTestId={testIDs.root}
            pageTitle={t("mod_integrations_avantio_title")}
            content={body}
            buttons={undefined}
        />
    );
}
